const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/KisimObjIcon/store/reducer.ts';
import Imm from 'immutable';
import { actionTypes, ILoadIconTypesAction, ILoadObjIconAction } from './actions';
import { Logger } from '../../../services/KisLoggerService';
import { makeReducer, IActionHandlersMap, IKisApiHandlersMap } from '../../../defs/actionTypes';
import { decCounter, incCounter } from '../../../utils/reducerUtils';

const emptyMap = Imm.Map<string, any>();
const Log = Logger('KisimObjIcon/reducer');

const loadIconTypesHandlers: IKisApiHandlersMap<ILoadIconTypesAction> = {
    pending: (state, _action) => {
        state = state.set('types', emptyMap);
        return incCounter(state, ['loading', 'iconTypes']);
    },
    success: (state, action) => {
        Imm.fromJS(action.payload?.List || {}).forEach((rec: Imm.Map<string, any>) => {
            const icode = rec.get('ICODE');
            const kat = rec.get('KAT');
            const fkey = rec.get('FKEY');
            const status = rec.get('STATUS');

            if (icode && kat === 'ObjectType' && fkey && status === 'A') {
                state = state.setIn(['types', fkey], icode);
            }
        });
        return decCounter(state, ['loading', 'iconTypes']);
    },
    failure: (state, action) => {
        Log.warn(`Action failed: ${action.type}`);
        return decCounter(state, ['loading', 'iconTypes']);
    },
};

const loadObjIconHandlers: IKisApiHandlersMap<ILoadObjIconAction> = {
    pending: (state, action) => {
        return incCounter(state, ['loading', 'icon', action.meta.metaKatFkey]);
    },
    success: (state, action) => {
        const kat = action.payload?.KAT;
        const status = action.payload?.STATUS;
        let name = '';

        if (kat === 'IconDefs' && status === 'A') {
            name = action.payload?.NAME ?? '';
        }

        state = state.setIn(['name', action.meta.metaKatFkey], name || 'failed'); // 'failed' prevents another attempt
        return decCounter(state, ['loading', 'icon', action.meta.metaKatFkey]);
    },
    failure: (state, action) => {
        // Since we don't have an icon for each and every combination, logging an error here is not useful.
        // But we mark the icon as 'failed', so we don't try to load it again.
        state = state.setIn(['name', action.meta.metaKatFkey], 'failed');
        return decCounter(state, ['loading', 'icon', action.meta.metaKatFkey]);
    },
};

const handlers: IActionHandlersMap = {
    [actionTypes.loadIconTypes.pending]: loadIconTypesHandlers.pending,
    [actionTypes.loadIconTypes.success]: loadIconTypesHandlers.success,
    [actionTypes.loadIconTypes.failure]: loadIconTypesHandlers.failure,

    [actionTypes.loadObjIcon.pending]: loadObjIconHandlers.pending,
    [actionTypes.loadObjIcon.success]: loadObjIconHandlers.success,
    [actionTypes.loadObjIcon.failure]: loadObjIconHandlers.failure,
};

export default makeReducer(handlers, undefined, 'kisimObjIcon');
